import handlebars from "handlebars";
const eq = (a: any, b: any) => a === b;

// Register the 'eq' helper with Handlebars
handlebars.registerHelper("eq", eq);
const equityAssetTemplate = `<!DOCTYPE html>
<html>
  <body>
    <div id="equityAsset">
    <div class="heading"><h6>Assets &nbsp; Level &nbsp; Details &nbsp;(Values &nbsp; in &nbsp;{{currency}} )</h6></div>

      <table id="equityAsset-table">
        <tr>
          <th colspan="2"></th>
          <th colspan="4">AE &nbsp; DCF &nbsp; Model</th>
          <th colspan="3">Appraisal</th>
        </tr>
        <tr>
          <th>Asset ID</th>
          <th>Asset</th>
          <th>DCF Value &nbsp; ( {{currencySymbol}} )</th>
          <th>Dicount Rate %</th>
          <th>Terminal Cap Rate %</th>
          <th>Implied Cap Rate Yr 1 %</th>
          <th>Curent Value &nbsp; ( {{currencySymbol}} )</th>
          <th>Previous &nbsp; ( {{currencySymbol}} )</th>
          <th>Past Year &nbsp; ( {{currencySymbol}} )</th>
        </tr>
        {{#each assets}}
        <tr>
          <td>{{this.id}}</td>
          <td>{{this.name}}</td>
          <td class ="rightAlign">{{this.dcfValue}}</td>
          <td class ="rightAlign">{{this.discountRate}}</td>
          <td class ="rightAlign">{{this.terminalCapRate}}</td>
          <td class ="rightAlign">{{this.impliedCapRateYr1}}</td>
          <td class ="rightAlign">{{this.currentAppraisalValue}}</td>
          <td class ="rightAlign">{{this.lastAppraisedValue}}</td>
          <td class ="rightAlign">{{this.lastAnnualAppraisedValue}}</td>
        </tr>
        {{/each}}

        {{#if (eq this.empty 'true')}}
        <tr>
          <td colspan="9">No  Data</td>
        </tr>
        {{/if}}
      </table>
    </div>
  </body>
</html>`
;

export default equityAssetTemplate;



// <style>
//       body {
//         font-family: Roboto, Helvetica, Arial, sans-serif;
//       }
//       #equityAsset table,
//       th,
//       td {
//         padding-top: 10px;
//         border: 1px solid #263746;
//         border-collapse: collapse;
//       }
//       #equityAsset table {
//         width: 100%;
//         border-radius: 3px !important;
//       }
//       #equityAsset th,
//       td {
//         padding: 15px;
//         text-align: center;
//       }
//       #equityAsset {
//         width: 100%;
//         border: 0.5px solid #263746;
//         border-radius: 3px;
//       }

//       #equityAsset  .heading {
//         margin: 0 !important;
//         background-color: #263746;
//         color: #fff;
//         padding: 10px;
//       }
//     </style>